import { toast } from "sonner";
import { Star } from "lucide-react";
import GenericListPanel from "./GenericListPanel";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { useContent } from "@/context/ContentContext";

export default function GalleryPanel() {
  const { adminApi } = useAuth();
  const { refresh } = useContent();

  const toggleFeatured = async (item, reload) => {
    try {
      if (item.featured) {
        await adminApi.post(`/gallery/unfeature`);
        toast.success("Featured cleared");
      } else {
        await adminApi.post(`/gallery/${item.id}/feature`);
        toast.success(`"${item.label}" set as Featured Project`);
      }
      await reload();
      refresh();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <GenericListPanel
      endpoint="gallery"
      testidPrefix="gallery"
      eyebrow="05"
      title="Project Gallery"
      description="Upload job photos. Star one item to feature it as this month's Project of the Month on the homepage."
      emptyItem={{
        label: "",
        alt: "",
        image_url: "",
        image_data: null,
        photos: [],
        video_url: "",
        order: 0,
        featured: false,
        featured_quote: "",
        featured_author: "",
      }}
      itemLabel={(it) => it.label}
      fields={[
        { name: "label", label: "Label (shown on the tile)", type: "text" },
        { name: "alt", label: "Alt Text (describe the job — used for accessibility & SEO)", type: "text" },
        { name: "photos", label: "Photos (first one is the cover shown on the tile)", type: "multi-image" },
        { name: "video_url", label: "Video URL (optional — MP4/WebM or YouTube). If set, this becomes a video project.", type: "text" },
        { name: "featured_quote", label: "Customer Quote (shown only when featured)", type: "textarea" },
        { name: "featured_author", label: "Quote Author (e.g. John S. — Waco, TX)", type: "text" },
      ]}
      rowClassName={(it) => (it.featured ? "border-[#FF6B00] shadow-[0_0_0_1px_#FF6B00]" : "border-white/10")}
      rowExtras={(item, { reload }) => (
        <button
          type="button"
          onClick={() => toggleFeatured(item, reload)}
          data-testid={`gallery-feature-${item.id}`}
          title={item.featured ? "Currently featured — click to clear" : "Mark as Featured Project of the Month"}
          className={`inline-flex items-center gap-1 px-3 py-2 text-xs font-display tracking-widest uppercase border transition-colors ${
            item.featured
              ? "bg-[#FF6B00] border-[#FF6B00] text-white"
              : "border-white/20 text-white/60 hover:text-[#FF6B00] hover:border-[#FF6B00]"
          }`}
        >
          <Star size={12} className={item.featured ? "fill-white" : ""} />
          {item.featured ? "Featured" : "Feature"}
        </button>
      )}
    />
  );
}
